/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskPortalSettingsType from '@jira/spa-apps__project-settings-service-desk-portal-settings/src/ExportedDefault.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import type { usePathParam } from '@atlassian/react-resource-router';

export const LazyProjectSettingsServiceDeskPortalSettings: LazyComponent<
	React.FunctionComponent<
		Omit<
			Omit<
				{
					useTenantContext: typeof useTenantContext;
					usePathParam: typeof usePathParam;
				},
				never
			> &
				Partial<unknown>,
			'useTenantContext' | 'usePathParam'
		>
	>
> = lazyForPaint<typeof ProjectSettingsServiceDeskPortalSettingsType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-portal-settings", jiraSpaEntry: "async-project-settings-service-desk-portal-settings" */ '@jira/spa-apps__project-settings-service-desk-portal-settings/src/ExportedDefault.tsx'
		),
);

const AsyncProjectSettingsServiceDeskPortalSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskPortalSettings}
		pageId="project-settings-portal-settings"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskPortalSettings;
